import React, {useState} from 'react'
import {
    Alert,
    Button, Card, Divider,
    Form,
    Input, notification,
    Typography
} from 'antd'
import Constants from "../../../const/Constants";
import TelegramLoginButton from "../../elements/buttons/TelegramLoginButton";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import GoogleAuthButton from "../../elements/buttons/GoogleAuthButton";
import AppAuthButton from "../../elements/buttons/AppAuthButton";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import {NavigationPages} from "../../../common/navigation/navigation-pages";
import {useAppDispatch} from "../../../store/hooks";
import * as API_USER from '../../../shared/http/user'
import {ErrorEnum} from "../../../common/error/error-enum";
import {UserDto} from "../../../shared/types/api";
import {setUserRoutine} from "../../../store/global";
import {goToPageNotPremium} from "../../utils/goToPage";
import {isRussianUser} from "../../../common/utils/geo";

const {Title, Text} = Typography

const LoginWizard: React.FC = () => {
    const [form] = Form.useForm()
    const [api, contextHolder] = notification.useNotification();
    const [loading, setLoading] = useState<boolean>(false)

    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const googleBlockedError = searchParams.get('error') === 'google_blocked_ru'

    const setReactUser = (uUser: UserDto) => dispatch(setUserRoutine(uUser))


    const onFinish = async (values: any) => {
        try {
            setLoading(true)
            const resp = await API_USER.login(values)
            if (resp.user) {
                setReactUser(resp.user)
                goToPageNotPremium(NavigationPages.GARDEN, navigate)
            }
        } catch (err: any) {
            if (err?.message) {
                switch (err.message) {
                    case ErrorEnum.EMAIL_NOT_CONFIRMED:
                        form.setFields([
                            {
                                name: 'login',
                                errors: ['Email не подтверждён. Пожалуйста, подтвердите его.']
                            }
                        ])
                        break
                    case ErrorEnum.WRONG_LOGIN_OR_PASSWORD:
                        form.setFields([
                            {
                                name: 'login',
                                errors: ['Неверный логин или пароль.']
                            },
                            {
                                name: 'password',
                                errors: ['Неверный логин или пароль.']
                            }
                        ])
                        break
                    default:
                        api.error({
                            message: `Ошибка`,
                            description: 'Неизвестная ошибка',
                            placement: 'topRight',
                        });
                }
            }
        } finally {
            setLoading(false)
        }
    }


    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                background: 'var(--color-bg-hover)'
            }}
        >
            {contextHolder}
            <Card
                style={{
                    maxWidth: 420,
                    width: '100%',
                    borderRadius: 12,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}
            >
                <Title level={3} style={{textAlign: 'center', marginBottom: 24}}>
                    Вход
                </Title>

                {googleBlockedError && (
                    <Alert
                        type="warning"
                        showIcon
                        style={{marginBottom: 16}}
                        message="Регистрация через Google временно недоступна. Пожалуйста, используйте другой способ входа."
                    />
                )}

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    requiredMark={false}
                >
                    <Form.Item
                        name="login"
                        label="Логин или Email"
                        rules={[{required: true, message: 'Введите логин или email'}]}
                    >
                        <Input
                            size="large"
                            prefix={<UserOutlined/>}
                            placeholder="example@mail.com"
                        />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        label="Пароль"
                        rules={[{required: true, message: 'Введите пароль'}]}
                    >
                        <Input.Password
                            size="large"
                            prefix={<LockOutlined/>}
                            placeholder="Ваш пароль"
                        />
                    </Form.Item>

                    <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        block
                        loading={loading}
                    >
                        Войти
                    </Button>
                </Form>

                <Divider plain>или войдите через</Divider>

                <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
                    {window.location.hostname === Constants.DOMAIN && (
                        <TelegramLoginButton
                            botName={'GeekenglishBot'}
                            buttonSize={'medium'}
                            cornerRadius={undefined}
                            requestAccess={'write'}
                            usePic={true}
                            dataAuthUrl={undefined as any}
                            lang={'ru'}
                            widgetVersion={19}
                            children={undefined}
                            className={'main-flex-center'}
                        />
                    )}
                    <GoogleAuthButton/>
                    {isRussianUser() && (
                        <Text type="secondary" style={{fontSize: 12}}>
                            Регистрация через Google временно недоступна для пользователей из России.
                        </Text>
                    )}
                    <AppAuthButton/>
                </div>

                <div
                    style={{
                        marginTop: 20,
                        fontSize: 14,
                        lineHeight: 1.6,
                        color: 'var(--color-text-secondary)',
                        textAlign: 'center'
                    }}
                >
                    Продолжая, вы соглашаетесь с нашей {' '}
                    <Link to="/personal-policy">политикой конфиденциальности</Link> и полностью принимаете
                    условия{' '}
                    <Link to="/aferta">Оферты</Link>.
                </div>


                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: 16
                    }}
                >
                    <Link to={NavigationPages.SIGN_UP}>
                        <Text type="secondary">Регистрация</Text>
                    </Link>
                    <Link to={NavigationPages.RESET_PASSWORD}>
                        <Text type="secondary">Забыли пароль?</Text>
                    </Link>
                </div>
            </Card>
        </div>
    )
}

export default LoginWizard
